import type { BonusPack } from '../types/domain';
import { LYRIC_TEMPLATE_FILES } from './lyricTemplates';

const VOICE_PACK_TITLES = [
  'Male Singing - Velvet Soul Tenor',
  'Male Singing - Arena Rock Powerhouse',
  'Male Singing - Afrobeats Golden Lead',
  'Male Singing - Cinematic Baritone',
  'Male Rapping - Deep Pocket Storyteller',
  'Male Rapping - Melodic Trap Vocalist',
  'Male Rapping - Agile Technical Flow',
  'Male Rapping - Dancehall Afro-Fusion',
  'Female Singing - Crystal Pop Soprano',
  'Female Singing - Smoky R&B Alto',
  'Female Singing - Gospel Powerhouse',
  'Female Singing - Indie Dream Voice',
  'Female Rapping - Precision Command',
  'Female Rapping - Melodic Rap Glow',
  'Female Rapping - Afro-Fusion Bounce',
  'Female Rapping - Dark Drill Focus',
] as const;

const SAMPLE_PACK_TITLES = [
  'Ember Horizon',
  'Neon Pursuit',
  'Desert Caravan',
  'Midnight Heist',
  'Celestial Drift',
  'Rising Resolve',
  'Rain on Glass',
  'Ancient Kingdom',
  'Arctic Light',
  'Urban Tension',
  'Golden Memory',
  'Shadow Protocol',
  'Wild Frontier',
  'Clockwork Wonder',
  'Deep Current',
  'Victory Circuit',
  'Quiet Investigation',
  'Sakura Dawn',
  'Iron March',
  'Moonlit Waltz',
  'Ashes and Snow',
  'Discovery Engine',
  'Temple Mist',
  'Retro Future Drive',
  'Paper Planes',
  'Titan Below',
  'Morning Market',
  'Zero Gravity Heart',
  'Breaking News Bed',
  'Forest Spirits',
  'Concrete Pulse',
  'Crown and Candle',
  'Solar Bloom',
  'Redline Escape',
  'Old Photographs',
  'Data Stream',
  'Harbor at Dusk',
  'Unseen Footsteps',
  'Festival Lanterns',
  'Final Frontier Log',
] as const;

/** Customer-safe bonus metadata. Prompt bodies are resolved only by the backend. */
export const CUSTOMER_BONUS_PACKS: BonusPack[] = [
  {
    id: 'lyric-templates',
    name: '50 lyric starter templates',
    desc: 'Premium lyric frameworks spanning every music genre available in Lyrixsa',
    kind: 'lyrics-template-file',
    published: true,
    textFiles: LYRIC_TEMPLATE_FILES,
  },
  {
    id: 'voice-pack',
    name: 'Premium voice prompt pack',
    desc: '16 distinct voice prompts: eight male and eight female styles for singing and rapping',
    kind: 'voice-pack-placeholder',
    published: true,
    voicePacks: VOICE_PACK_TITLES.map((title) => ({ title, contents: '' })),
    note: 'Includes eight male and eight female premium voice directions, evenly split between singing and rapping. Claim the bonus, open the pack, and select up to two voices for your next creation.',
  },
  {
    id: 'sample-pack',
    name: 'Cinematic sample pack',
    desc: '40 royalty-free instrumental loops for adding cinematic textures and musical ideas to creations.',
    kind: 'sample-pack-files',
    published: true,
    samplePrompts: SAMPLE_PACK_TITLES.map((title) => ({ title, prompt: '' })),
  },
];
